import Vue from 'vue'
import Router from 'vue-router'
import Cookies from 'js-cookie'
import store from '@/store'

Vue.use(Router)

// 验证token是否有效的辅助函数
function isValidToken(token) {
  if (!token) return false

  try {
    // 检查token格式和过期时间
    const payload = JSON.parse(atob(token.split('.')[1]))
    const now = Date.now() / 1000

    // 如果token已过期，返回false
    if (payload.exp && payload.exp < now) {
      return false
    }

    return true
  } catch (error) {
    // 如果token格式不正确，返回false
    return false
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/layout/dashboard'
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/Login'),
      meta: { requiresAuth: false }
    },
    {
      path: '/layout',
      component: () => import('@/layout/Layout'),
      meta: { requiresAuth: true },
      redirect: '/layout/dashboard',
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: () => import('@/views/Dashboard'),
          meta: { title: '仪表板' }
        },
        {
          path: 'users',
          name: 'UserManagement',
          component: () => import('@/views/UserManagement'),
          meta: { title: '用户管理' }
        },
        {
          path: 'synthesis',
          name: 'SynthesisManagement',
          component: () => import('@/views/SynthesisManagement'),
          meta: { title: '合成管理' }
        },
        {
          path: 'points',
          name: 'PointsManagement',
          component: () => import('@/views/PointsManagement'),
          meta: { title: '积分管理' }
        },
        {
          path: 'exchange-codes',
          name: 'ExchangeCodeManagement',
          component: () => import('@/views/ExchangeCodeManagement'),
          meta: { title: '兑换码管理' }
        },
        {
          path: 'voice-models',
          name: 'VoiceModelManagement',
          component: () => import('@/views/VoiceModelManagement'),
          meta: { title: '语音模型管理' }
        },
        {
          path: 'settings',
          name: 'SystemSettings',
          component: () => import('@/views/SystemSettings'),
          meta: { title: '系统设置' }
        },
        {
          path: 'security',
          name: 'SecurityManagement',
          component: () => import('@/views/SecurityManagement'),
          meta: { title: '安全管理' }
        }
      ]
    }
  ]
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = Cookies.get('admin_token')
  const isTokenValid = isValidToken(token)

  // 如果访问的是需要认证的路由但没有有效token，跳转到登录页
  if (to.meta.requiresAuth !== false && !isTokenValid) {
    // 清除无效的管理员信息
    Cookies.remove('admin_user')
    Cookies.remove('admin_token')
    store.dispatch('logout')

    // 显示未授权消息
    if (to.path !== '/login') {
      // 使用setTimeout确保消息在路由跳转后显示
      setTimeout(() => {
        const { Message } = require('element-ui')
        Message.error('登录已过期或无访问权限，请重新登录')
      }, 100)
    }

    next('/login')
  } else if (to.path === '/login' && isTokenValid) {
    // 如果已登录但访问登录页，跳转到仪表板
    next('/layout/dashboard')
  } else {
    next()
  }
})

export default router
